<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        01.18
        <br />2019
      </span>
      <span class="tiel">美菜网CEO刘传军：价值观远比钱更重要</span>
    </div>
    <div class="mat-content">
      <div class="tet-js">
        近日，"2019中国新时代企业创新论坛"暨"2019年商业模式创新优秀品牌"发布会于北京人民大会堂召开，该次大会是由中国产经新闻报社、中国电子商务协会新零售行业分会、企业家日报社、中国民营科技实业家协会品牌管理工作委员会联合举办的。在本次大会中，美菜网凭借全国采购计划，获得"2019全国优秀商业模式创新企业"奖，而创始人刘传军获得"2019全国社会突出贡献优秀企业家"称号。
        <br />
        <br />
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/d011_1.jpeg" width="640" />
      </p>

      <div class="tet-js">
        本次活动得到了来自部委领导的大力支持，邀请了品牌行业专家、行业媒体、知名企业等800多人齐聚一堂，以"新时代 新征程 新高度"为主题，共话新时代品牌创新发展。大会最终评选出"十佳创新企业"、"商业模式创新企业"、"社会突出贡献优秀企业家""最具投资潜力企业"等六大奖项，旨在深入解读和剖析成功企业案例和这些案例背后的企业负责人，并在行业内宣传其成功作为，以其成功经验、先进模式和丰硕成果来启迪、指导和帮助同业取得更大成功。
        <br />
        <br />
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/d011_2.jpeg" width="640" />
      </p>

      <div class="tet-js">
        美菜网作为中国餐饮供应链杰出服务商，其通过自主研发移动电商平台，自建仓储、物流、配送体系，创新升级了农产品供应链。其"两端一链一平台"的创新模式，一端链接田间地头，一端链接城市餐桌，实现农产品从地头到餐桌高速的流通。目前，业务覆盖超220个城市，累计服务超过商户270万家。给很多农民和商家留下了"买菜卖菜上美菜"的品牌印象。这一模式给餐饮商家带来"价格无忧，选择无忧，品类无忧，服务无忧"的无忧体验。让餐厅拥有稳定的供货渠道，既大大地降低了餐饮行业的采购成本，也减少了企业的运营风险。
        <br />
        <br />创始人刘传军本着"为8亿农民谋幸福"的这份初心，自2014年创立美菜至今，推行产地直供直采、精准扶贫，这一场从初心出发的直奔目标而去的战略行动，非常精准地与8亿农民的血脉紧紧联系在了一起。 对上游农民来说，他们可以利用美菜自主研发的大数据系统，一键了解农产品价格走向。从源头指导农民生产、建立产地标准，避免了农产品货不对市的问题，帮农民增产增收。
        <br />
        <br />不仅如此，自2017年以来，美菜实施了"SOS精准扶贫全国采购计划"足迹遍及全国22个地区，采购滞销农产品总量2653.4万斤。其中，仅环京津34个贫困地区的农产品采购总量就达到8306.2万斤。
        <br />
        <br />刘传军表示，"农民发现农产品滞销后找美菜网"。过去一年，美菜网已累计做了100多次紧急救助，均取得了非常显著的成效。还有人问我，要卖多少菜，才能赚回做公益的钱？这是一个不容回避的问题，公益需要钱，但是光有钱是远远不够的，因为公益和慈善还有差异，慈善在于给予，而公益在于参与，在于点点滴滴的行动。公益需要花出的是时间、激情、智慧以及所有你可能拿不出来的东西。"我坚信，价值观要远比钱更重要。"
        <br />
        <br />美菜网的成功并不是偶然，它把社会责任担到了肩上，不管是精准扶贫项目，还是全国采购计划，这其中突显出的正是美菜网强烈的社会荣誉感，不仅为人民大众谋福利，也为企业发展带去了蓬勃生机。
        <br />
        <br />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
